import { Injectable } from '@angular/core';
import { Account } from '../../models/account.model';
import { HttpClient } from '@angular/common/http';
import { Base64 } from 'js-base64';
import { AppUser } from 'src/app/models/app-user.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvironmentService } from './environment.service';
import { BackOfficeService } from 'src/app/services/back-office.service';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { AppConstant } from 'src/app/constants/app.constant';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { ItokenProperties } from 'src/app/models/token/tokenProperties.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private appUser: AppUser;
  private accountList: Account[] = [];
  private localStorageTokenName = "token";
  private localStorageShoppingCart = "shoppingCart";
  private localStorageTokenProperties = "tokenProperties";
  public tokenLifeTimeExceeded: boolean = false;

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private backOfficeService: BackOfficeService,
    private router: Router,
    private accountService: AccountService) {
  }

  getAccountListFroMemory(): Account[] {
    return this.accountList;
  }
  setAccountListToMemory(accountList: Account[]) {
    this.accountList = accountList;
  }
  addAccountToMemory(account: Account) {
    this.accountList.push(account);
  }
  deleteAccountFromMemory(account: Account) {
    this.accountList.splice(this.accountList.indexOf(account), 1);
    return this.accountList;
  }
  setAuthToken(jwt: string) {
    localStorage.setItem(this.localStorageTokenName, jwt);
  }
  getAuthToken(): string {
    return localStorage.getItem(this.localStorageTokenName);
  }
  deleteAuthToken() {
    localStorage.removeItem(this.localStorageTokenName);
  }
  getCreditLineFNB(): CreditLineFNB {
    if (this.environmentService.encryptEnabled) {
      let dataEncrypted = localStorage.getItem(AppConstant.accountBasicData);
      if (dataEncrypted != null) {
        let dataDecrypted = Base64.decode(dataEncrypted);
        let accountBasicData = JSON.parse(dataDecrypted) as AccountBasicData;
        return (accountBasicData == null) ? null : accountBasicData.creditLineFNB;
      }
      return null;
    } else {
      let accountBasicData = JSON.parse(localStorage.getItem(AppConstant.accountBasicData)) as AccountBasicData;
      return (accountBasicData == null) ? null : accountBasicData.creditLineFNB;
    }
  }
  getBasicData(): AccountBasicData {
    if (this.environmentService.encryptEnabled) {
      let dataEncrypted = localStorage.getItem(AppConstant.accountBasicData);
      if (dataEncrypted != null) {
        let dataDecrypted = Base64.decode(dataEncrypted);
        return JSON.parse(dataDecrypted) as AccountBasicData;
      }
      return null;
    } else {
      return JSON.parse(localStorage.getItem(AppConstant.accountBasicData)) as AccountBasicData;
    }
  }
  deleteShoppingCart() {
    localStorage.removeItem(this.localStorageShoppingCart);
  }
  getUser() {
    return this.appUser;
  }
  getUserWithToken(jwt: string): AppUser {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(jwt);
    const result = new AppUser();
    result.id = decodedToken.unique_name;
    result.emailAddress = decodedToken.Email;
    result.fullName = decodedToken.FullName;

    return result;
  }
  setUser(jwt: string) {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(jwt);
    this.appUser = new AppUser();
    this.appUser.id = decodedToken.unique_name;
    this.appUser.emailAddress = decodedToken.Email;
    this.appUser.fullName = decodedToken.FullName;
    localStorage.removeItem('appEmail');
    window.localStorage.setItem('appEmail', this.appUser.emailAddress);
    window.localStorage.setItem('fullName', this.appUser.fullName);

    // console.log(decodedToken);
    // Other functions
    // const expirationDate = helper.getTokenExpirationDate(myRawToken);
    // const isExpired = helper.isTokenExpired(myRawToken);
  }
  async logOut() {
    let bandera = false;
    bandera = this.accountService.getBandera();
    await this.backOfficeService.closeSession().toPromise();
    this.deleteAuthToken();
    this.accountService.deleteStorageBasicData();
    if (bandera == true) {
      window.location.href = this.environmentService.portalWebUrl + "atencion-al-cliente/registrar-reclamos#seccion?reg=1";
      //Descomentar para producción
      //window.location.href =  this.environmentService.portalWebUrl + "atencion-al-cliente/registrar-reclamos#seccion";
    }
    else {
      window.location.href = this.environmentService.portalWebUrl;
    }
  }

  /**Valida si la página web está dentro de un iframe */
  checkIfItIsInsideIframe() {
    const result = !(self == top);
    // console.log('checkIfItIsInsideIframe() =>', result);
    localStorage.setItem('_fromIframe', result.toString());
    return result;
  }

  IsStandaloneModule() {
    const result = this.router.url.startsWith('/stdln');
    // console.log('URL', this.router.url);
    //console.log('IsStandaloneModule() =>', result);
    localStorage.setItem('_isStandaloneModule', result.toString());
    return result;
  }

  setTokenProperties(tokenProperties: any) {
    const properties: ItokenProperties = {
      createDate: tokenProperties['createDate'],
      expireDate: tokenProperties['expireDate']
    }
    localStorage.setItem(this.localStorageTokenProperties, JSON.stringify(properties));
  }

  getTokenProperties(): ItokenProperties {
    let tokenProperties: ItokenProperties;
    const data = localStorage.getItem(this.localStorageTokenProperties);
    if (data) {
      tokenProperties = JSON.parse(data);
    }
    return tokenProperties;
  }

}
